// Feature flags utility
export const isFeatureEnabled = (featureName: string): boolean => {
  // Check environment variable first
  const envValue = import.meta.env[`VITE_ENABLE_${featureName.toUpperCase()}`];
  if (envValue !== undefined) {
    return envValue === 'true';
  }
  
  // Default values for features
  const defaultValues: Record<string, boolean> = {
    COMING_SOON: true, // Default to showing coming soon pages
  };
  
  return defaultValues[featureName] ?? false;
};

// Specific feature flag getters
export const isComingSoonEnabled = (): boolean => {
  return isFeatureEnabled('COMING_SOON');
}; 